import React from 'react';
import App from './App';
import './main.css';
import ReactDOM from 'react-dom/client';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <App />
);
